export default "__VITE_ASSET__abace2e0__"